import Fondo from "../assets/fondoInicio.png";
import Celular from "../assets/celular.png";
import GPS from "../assets/GPS.png";

const Inicio = () => {
    return (
        <div
            className="w-full h-screen bg-cover bg-center grid grid-cols-1 md:grid-cols-2 pt-20"
            style={{ backgroundImage: `url(${Fondo})` }}
        >
            <div className="w-full px-4 md:px-20 flex flex-col items-center justify-center gap-3">
                <h1 className="text-xl text-red-600 md:text-6xl font-bold">Rastreo GPS</h1>
                <p className="text-justify text-white md:text-gray-500 bg-gray-500/75 md:bg-transparent p-4 rounded-lg text-base md:text-2xl">Especializados en la implementación de localizadores GPS de vehículos y mercancías.</p>
            </div>
            <div className="relative">
                <img src={Celular} className="w-full aspect-square" alt="Celular" />
                <img src={GPS} className="absolute bottom-0 left-0 w-3/5 aspect-square" alt="GPS" />
            </div>
        </div>
    );
};

export default Inicio;